import axios from 'axios';

const API = axios.create({
  baseURL: 'https://app.tempogestion.es',
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (!config.url.startsWith('/auth') && !config.url.startsWith('/api/superadmin')) {
    config.url = '/api' + config.url;
  }
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    if (err.response?.status === 402) {
      window.location.href = '/trial-expirado';
    }
    return Promise.reject(err);
  }
);

export default API;
